import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { CustomCol, FormLabels, CustomInputNumber } from 'src/components'

const AcquisitionStockField: React.FC = () => {
  const { t } = useTranslation()

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('admin.Brokerage.Stock')}
        subtitle={t('general.RequiredField')}
      />
    </CustomCol>
    <CustomCol>
      <CustomInputNumber
        name={'stock'}
        placeholder={t('admin.Brokerage.StockPlaceHolder')}
        required
      />
    </CustomCol>
  </Row>
}

export default AcquisitionStockField
